module.exports = __webpack_public_path__ + "img/EMT-OSCC_GSE208253.b84359d6.png";